"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PinterestIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Pinterest_svg_1 = __importDefault(require("./Pinterest.svg"));
/**
 * Pininterest Icon.
 * figma link - https://www.figma.com/file/M9VCQnWUmAbbRy9VXOtlwO/Atomic-Icons?node-id=916%3A916
 */
function PinterestIcon() {
    return (0, jsx_runtime_1.jsx)(Pinterest_svg_1.default, {});
}
exports.PinterestIcon = PinterestIcon;
//# sourceMappingURL=PinterestIcon.js.map